import { useCallback } from 'react';
import { convertToFeetInchesNumericFormat } from '../../common/helpers/utils';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { EntityPanelFormPersonBaseKey, EntityPanelPersonsForm } from '../entity-panels/forms/types';

export function useConvertPersonHeightToFeetInchesNumericFormat({
    baseKey,
    index,
}: {
    baseKey: EntityPanelFormPersonBaseKey;
    index: number;
}) {
    const { form } = useIntegratedForm<EntityPanelPersonsForm>();

    return useCallback(
        (heightFieldName: 'heightMax' | 'heightMin' | 'height') => {
            const height = form.getValues(`${baseKey}.${index}.${heightFieldName}`);

            if (!height) {
                return;
            }

            form.setValue(
                `${baseKey}.${index}.${heightFieldName}`,
                String(convertToFeetInchesNumericFormat(Number(height)))
            );
        },
        [baseKey, form, index]
    );
}
